import styled from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import { CustomHollowButton } from "../buttons";

export const CustomButton = styled(CustomHollowButton)`
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.navbar.exit.border.notActive.color};
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto;
  width: auto;
  padding-left: 24px;
  padding-right: 24px;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   height: 32px !important;
  // }
`;import styled from "styled-components";
import { LayoutConst } from "core/modules/layout.module";
import { CustomHollowButton } from "../buttons";

export const CustomButton = styled(CustomHollowButton)`
  border: 1px solid ${({ theme }) => theme.projectEdit.btns.navbar.exit.border.notActive.color};
  height: 38px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto;
  width: auto;
  padding-left: 24px;
  padding-right: 24px;

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    height: 38px !important;
  }


  // @media(max-width: ${LayoutConst.screen.m_1024}px) {
  //   height: 32px !important;
  // }
`;